module.exports = __webpack_public_path__ + "static/media/simpleImg.95df5acb.jpg";